import Base from './base'

export default {
  get (year, make, model) {
    return Base
      .get(`/vehicleattributes/year/${year}/makeid/${make}/modelid/${model}/attributes`)
      .then(res => res.data[0])
  }
}
